import React, { Component } from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { applyDataTable, destroyDataTable } from '../../custom/dataTable';
import downloadIcon from '../../../assets/img/svg/DownloadIcon.svg';
import shareIcon from '../../../assets/img/svg/ShareIcon.svg';
import danger from '../../../assets/img/svg/Danger.svg';
import del from '../../../assets/img/svg/Del.svg';
import FilterIcon from '../../../assets/img/svg/FilterIcon.svg'
import { TextField } from '@material-ui/core';
import Pagination from "../../custom/Pagination";
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { Autorenew } from '@material-ui/icons';
import upload from '../../../assets/img/svg/upload.svg';
import deleteIcon from '../../../assets/img/svg/delete.svg';
import $ from 'jquery';
import Divider from '@material-ui/core/Divider';
import PropTypes from 'prop-types';
import styles from "../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import moment from "moment"
import axios from "axios";
import API from "../../../_helpers/endpointService";
import { getSettingsFormat } from "../../../actions/SettingsAction"
import View from '../../../assets/img/svg/view.svg';
import { Buffer } from 'buffer';

class FinalReport extends Component {
    constructor(props) {
        super(props);
        this.multiselectRef = React.createRef();
        this.state = {
            isMobile: false,
            isError: false,
            report: "",
            reportslist: [],
            showReport: false,
            addData: {
                Id: 0,
                ShareByEmail: false,
                StartDate: "",
                EndDate: "",
                Description: "",
                Email: [],
                UniqueId: '',

            },
            ProjectId: 0,
        }
    }

    componentDidMount() {
        this.state.addData.Id = parseInt(localStorage.getItem("DashId"));
        this.state.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.setState({})
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.getReportList(this.state.ProjectId, "final");
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    getReportList = (id,data) => {
        let apiUrl = API.REPORTS_LISTVIEW + '?id=' + id + '&type=' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
            data: data,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.reportslist = response?.data;
                    this.setState({})
                }
                else {

                }
            })

            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    Regenerate = (data, startdate, enddate) => {
        let apiUrl = API.REPORTS_CHANGESTATUS + '?projectid=' + data + '&type=' + "final" + '&startdate=' + startdate + '&enddate=' +enddate;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.getReportList(this.state.ProjectId, "final");
                }
                else {

                }
            })

            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    viewreport = (startdate, enddate, i, index) => {
        this.state.reportslist.map((i, ind) => {
            if (ind === index) {
                this.state.addData = {
                    Id: parseInt(localStorage.getItem("DashId")),
                    StartDate: i.StartDate,
                    EndDate: i.EndDate,
                    Description: i.Description,
                    ShareByEmail: false,
                    Email: [],
                    UniqueId: i.ReportUniqueId,
                }
                this.setState({})
            }
      })
        this.state.showReport = true;
        this.setState({})
        this.getfinalreport(this.state.ProjectId,startdate, enddate)
    }

    getfinalreport = (data,startdate, enddate) => {
        let apiUrl = API.FINAL_REPORTSHOW + '?id=' + data + '&startdate=' + startdate + '&enddate=' +enddate;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.addData.UniqueId = response?.data.UniqueId
                    this.setState({})
                    this.toBase64(response?.data.SourceHtml);
                }
                else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    toBase64(data) {
        let buff = Buffer.from(data);
        let stringToBase64 = buff.toString('base64');
        this.state.report = stringToBase64;
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#FINAL1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#FinalReport1 .MuiListItemText-primary").addClass("fw-bolder")
        $("#FinalReport").removeClass("d-none")
        $("#FinalReport").addClass("d-block")
        $("#FR .MuiListItemText-primary").addClass("fw-bolder")
        $("#FRL").addClass("active-color")
    };


    DownloadReport = (i) => {
        this.state.addData.Id = parseInt(localStorage.getItem("DashId"));
        this.state.addData.Description = i.Description;
        this.state.addData.StartDate = i.StartDate;
        this.state.addData.EndDate = i.EndDate;
        this.state.addData.UniqueId = i.ReportUniqueId;
        this.setState({})
        if (this.state.addData.Id != 0) {
            this.DownloadPreCuttingReport(this.state.addData)
        }
    }

    DownloadReports = () => {
        if (this.state.addData.Id != 0) {
            this.DownloadPreCuttingReport(this.state.addData)
        }
    }

    DownloadPreCuttingReport = (data) => {
        let apiUrl = API.FINAL_REPORT_DOWN;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
            responseType: "blob",

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    let fileName = response.headers['content-disposition'].split('filename="')[1].split('";')[0];
                    let blob = new Blob([response.data]);
                    let url = URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    a.click();
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#FINAL1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#FinalReport1 .MuiListItemText-primary").removeClass("fw-bolder")
        $("#FinalReport").addClass("d-none")
        $("#FinalReport").removeClass("d-block")
        $("#FR .MuiListItemText-primary").removeClass("fw-bolder")
        $("#FRL").removeClass("active-color")
    }
    sidebar = () => {
        this.props.navigate("/sidebarreport");
    }
    Cancel = () => {
        // this.multiselectRef.current.resetSelectedValues();
        this.state.showReport = false;
        this.setState({})
    }
    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100  mt-4">
                                <div className="col-5 w-50 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"FINAL" + "1"} className=' textNaviIcon' primary="Reports" />
                                            <NavigateNextIcon id="FINAL" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-7 pt-3 mt-5 w-50">
                                    <h4>Final Report</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                {this.state.showReport == false ?
                    <div className={this.state.isMobile ? this.state.UserRole === "YardInCharge" ? "ml-auto scroll-hide border-top" : "ml-auto scroll-hide" : "ml-auto scroll-hide"} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                        {this.state.reportslist.length == 0 ?   
                        <div className="row px-4 mt-5 pt-5 py-3">
                        <div className="col-12 pb-2 text-center">
                            <h6>No data to display</h6>
                        </div>
                        </div> :
                        <div className="row px-4 py-3">
                            <div className="col-12 pb-2">
                                {this.state.isMobile ? <></> : <h6>Final Report</h6>}
                            </div>
                            <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12">
                                <div className="table-responsive" style={{ width: "100%" }}>
                                    <table id="Docstable" className="table table-borderless border-top border-bottom border-left border-right">
                                        <thead>
                                            <tr className="table-active">
                                                <th width="95%" colSpan={2} className="border-right"><span className="spandoc-thead">Report</span></th>
                                                <th width="5%" className="border-right"><span className="spandoc-thead Nowrap">Created On</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.reportslist.length > 0 ?
                                            this.state.reportslist.map((i,ind)=>(
                                                <tr className="border-top">
                                                <td className={`${window.innerWidth < 1080 ? "Nowrap" : ""} align-middle`}>
                                                    <span className="spandoc-td">Final Report</span>
                                                </td>
                                                <td className="border-right text-right Nowrap align-middle">
                                                    {(i.Status.toLowerCase() == "regeneration pending" || i.Status.toLowerCase() == "regeneration inprogress") ?
                                                    <button className="pendingre-button">RE-GENERATION IN PROGRESS</button> :
                                                     i.Status.toLowerCase() == "completed" ?
                                                    <button className="completed-button">COMPLETED</button> :
                                                    <button className="pending-button">PENDING</button> }
                                                    {i.Status.toLowerCase() == "completed" ? <>
                                                    <img src={View} className="cursorPointer pl-2 ml-1 viewdel-td" onClick={()=> this.viewreport(i.StartDate, i.EndDate, i, ind)} />
                                                    <span className="pl-1 pr-2 py-2 cursorPointer link-color" onClick={()=> this.viewreport(i.StartDate, i.EndDate, i, ind)}>View</span>
                                                    <img className="" src={downloadIcon} style={{ marginTop: '-4px' }} onClick={() => this.DownloadReport(i)}></img>
                                                    <span className="pl-1 pr-2 py-2 cursorPointer" onClick={() => this.DownloadReport(i)}>Download</span></> : <>
                                                    <img src={View} className="cursorPointer pl-2 ml-1 viewdel-td" style={{ opacity: "0.5" }} />
                                                    <span className="pl-1 pr-2 py-2 cursorPointer link-color" style={{ opacity:  "0.5" }}>View</span>
                                                    <img className="" src={downloadIcon} style={{ marginTop: '-4px', opacity: "0.5" }}></img>
                                                    <span className="pl-1 pr-2 py-2 cursorPointer" style={{ opacity: "0.5" }}>Download</span></> }
                                                    {((localStorage.getItem("UserRoles").toLowerCase() == "admin" || localStorage.getItem("UserRoles").toLowerCase() == "supervisor" ) && i.Status.toLowerCase() == "completed") ? <>
                                                    <Autorenew style={{ width: '16px', height: '16px', color: '#00838F', marginTop: '-4px', opacity: i.Status.toLowerCase() == "completed" ? "" : "0.5" }} onClick={() => this.Regenerate(this.state.ProjectId, i.StartDate, i.EndDate)} />
                                                    <span className="pl-1 pr-2 py-2 cursorPointer" onClick={() => this.Regenerate(this.state.ProjectId, i.StartDate, i.EndDate)}>Re-Generate</span></> : 
                                                    ((localStorage.getItem("UserRoles").toLowerCase() == "admin" || localStorage.getItem("UserRoles").toLowerCase() == "supervisor" ) && i.Status.toLowerCase() != "completed") ? <>             
                                                    <Autorenew style={{ width: '16px', height: '16px', color: '#00838F', marginTop: '-4px', opacity: "0.5" }} />
                                                    <span className="pl-1 pr-2 py-2 cursorPointer" style={{ opacity: "0.5" }}>Re-Generate</span></> :""}
                                                </td>
                                                <td className="spandate-thead border-right text-center align-middle">
                                                    <span className="">{i.CreatedDate && moment(i.CreatedDate).format((this.props.settings.Convention == "DD/MM/YYYY" || this.props.settings.Convention == "MM/DD/YYYY") ? this.props.settings.Convention : "DD/MM/YYYY")}</span>
                                                </td>
                                            </tr>
                                            ))
                                            :
                                            <>
                                              <tr className="border-top">
                                                <td className={`${window.innerWidth < 1080 ? "Nowrap" : ""} align-middle`}>
                                                    <span className="spandoc-td">Final Report</span>
                                                </td>
                                                <td className="border-right text-right Nowrap align-middle">
                                                    <button className="pending-button">PENDING</button>
                                                    <img src={View} className="cursorPointer pl-2 ml-1 viewdel-td" style={{ opacity: "0.5" }} />
                                                    <span className="pl-1 pr-2 py-2 cursorPointer link-color"  style={{ opacity: "0.5" }}>View</span>
                                                    <img className="" src={downloadIcon} style={{ marginTop: '-4px',opacity: "0.5" }}></img>
                                                    <span className="pl-1 pr-2 py-2 cursorPointer"  style={{ opacity: "0.5" }}>Download</span>
                                                    <Autorenew style={{ width: '16px', height: '16px', color: '#00838F', marginTop: '-4px', opacity: "0.5" }} />
                                                    <span className="pl-1 pr-2 py-2 cursorPointer"  style={{ opacity: "0.5" }}>Re-Generate</span>
                                                </td>
                                                <td className="spandate-thead border-right text-center align-middle">
                                                    <span className=""></span>
                                                </td>
                                            </tr>
                                            </> }
                                            {/* <tr className="border-top">
                                                <td className={`${window.innerWidth < 1080 ? "Nowrap" : ""} align-middle`}>
                                                    <span className="spandoc-td">Pre Cutting Report</span>
                                                </td>
                                                <td className="border-right text-right Nowrap align-middle">
                                                    <button className="pending-button">PENDING</button>
                                                    <img src={View} className="cursorPointer pl-2 ml-1 viewdel-td" />
                                                    <span className="pl-1 pr-2 py-2 cursorPointer link-color">View</span>
                                                    <img className="" src={downloadIcon} style={{ marginTop: '-4px' }}></img>
                                                    <span className="pl-1 pr-2 py-2 cursorPointer" onClick={() => this.DownloadReport()}>Download</span>
                                                    <Autorenew style={{ width: '16px', height: '16px', color: '#00838F', marginTop: '-4px' }} />
                                                    <span className="pl-1 pr-2 py-2 cursorPointer" onClick={() => this.DownloadReport()}>Re-Generate</span>
                                                </td>
                                                <td className="spandate-thead border-right text-center align-middle">
                                                    <span className="">28/10/2022</span>
                                                </td>
                                            </tr>
                                            <tr className="border-top">
                                                <td className={`${window.innerWidth < 1080 ? "Nowrap" : ""} align-middle`}>
                                                    <span className="spandoc-td">WEEK-100 (From 17 Jan'2022 To 22 Jan'2022)</span>
                                                </td>
                                                <td className="border-right text-right Nowrap align-middle">
                                                    <button className="pendingre-button">RE-GENERATE IN PROGRESS</button>
                                                    <img src={View} className="cursorPointer pl-2 ml-1 viewdel-td" />
                                                    <span className="pl-1 pr-2 py-2 cursorPointer link-color">View</span>
                                                    <img className="" src={downloadIcon} style={{ marginTop: '-4px' }}></img>
                                                    <span className="pl-1 pr-2 py-2 cursorPointer" onClick={() => this.DownloadReport()}>Download</span>
                                                    <Autorenew style={{ width: '16px', height: '16px', color: '#00838F', marginTop: '-4px' }} />
                                                    <span className="pl-1 pr-2 py-2 cursorPointer" onClick={() => this.DownloadReport()}>Re-Generate</span>
                                                </td>
                                                <td className="spandate-thead border-right text-center align-middle">
                                                    <span className="">28/10/2022</span>
                                                </td>
                                            </tr> */}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>}
                    </div> :
                    <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : this.props.menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                        {this.state.isMobile ?
                            <table className="dataTable border-top" width="100%" >
                                <tbody>
                                    <tr className="" width='5%'>
                                        <td className="border-right text-center">
                                            <i class="fa fa-arrow-left cursorPointer" onClick={this.Cancel}></i>
                                        </td>
                                        <td className="border-right" width='95%'>
                                            <img className="" src={downloadIcon} style={{ marginTop: '-4px' }}></img>
                                            <span className="p-2 cursorPointer" onClick={() => this.DownloadReports()}>Download</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            : <>
                                <table className="dataTable">
                                    <tbody>
                                        <tr className="">
                                            <td width="5%" className="border-right text-center">
                                                <i class="fa fa-arrow-left cursorPointer" onClick={this.Cancel}></i></td>
                                            <td className="">
                                                <img className="pl-2" src={downloadIcon} style={{ marginTop: '-4px' }}></img>
                                                <span className="p-2 cursorPointer" onClick={() => this.DownloadReports()}>Download</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </>
                        }
                        <div>
                            <iframe src={"data:text/html;base64," + this.state.report} style={{ width: "100%", height: "calc(100vh - 111px)" }} ></iframe>
                        </div>
                    </div>
                }
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
    };
}
FinalReport.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(FinalReport)));
